<app-header [title]="yakkan_name"></app-header>
<app-sidebar [sidebars]="sidebar"></app-sidebar>

<div class="yakkan_window">
  <div class="yakkan_hidari">←</div>
  <div class="yakkan_honbun">
    <p *ngIf="is_yakkan" class="yakkan_text">
      <img [src]="yakkan[side_index].path" class="yakkan_img" />
    </p>

    <p *ngIf="!is_yakkan" class="yakkan_text">
      <img [src]="kiyaku[side_index].path" class="yakkan_img" />
    </p>
  </div>
  <div class="yakkan_migi">
    →
  </div>
</div>
<app-footer></app-footer>
